import { Place } from "@/types";
import { Card, CardDescription, CardTitle } from "./ui/card";

export default function FCCard({
  place,
  opts,
  onClick,
}: {
  place: Place & { uid: string };
  opts: { primaryColor: string };
  onClick?: () => void;
}) {
  return (
    <Card x-chunk="dashboard-05-chunk-1" className="w-full" onClick={onClick}>
      <div className="flex items-center justify-center p-1">
        <img
          src={
            "https://e39eyh4aj96.exactdn.com/wp-content/uploads/elementor/thumbs/Principale-4-qm9miybpwkied3i43h8h4r9rli44zoxs0nt5kvjnx4.jpg?strip=all&lossy=1&w=1920&ssl=1"
          }
          alt="Pizzium Place Card Header"
          className=" w-full rounded-lg"
        />
      </div>

      <div className="space-y-2 p-2 pb-4">
        <CardTitle className={`text-2xl`} style={{ color: opts.primaryColor }}>
          {place.name}
        </CardTitle>
        <CardDescription>{place.address}</CardDescription>
      </div>
    </Card>
  );
}
